import { styled } from "../../../../../styles";

export const VersionBarContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  paddingBottom: "16px",
  borderBottom: "1px solid $gray-40",
});

export const BarRow = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
});

export const BarGroup = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "12px",
});

export const Badge = styled("span", {
  padding: "4px 12px",
  borderRadius: "16px",
  fontFamily: "$openSans",
  fontSize: "13px",
  fontWeight: 600,

  variants: {
    tone: {
      live: { backgroundColor: "$success-lightest", color: "$success-dark" },
      draft: { backgroundColor: "$caution-lightest", color: "$caution-darker" },
      previous: { backgroundColor: "$gray-40", color: "$charcoal" },
    },
  },
});

export const IssuesList = styled("div", {
  padding: "12px 16px",
  borderRadius: "8px",
  backgroundColor: "$error-lightest",
  color: "$error-dark",
  fontFamily: "$openSans",
  fontSize: "14px",

  ul: {
    margin: "8px 0 0 0",
    paddingLeft: "20px",
  },
});

export const HelpIcon = styled("button", {
  display: "inline-flex",
  alignItems: "center",
  padding: 0,
  border: "none",
  background: "none",
  color: "$gray-100",
  cursor: "help",

  "&:focus-visible": { outline: "2px solid var(--colors-button-focus-border)" },
});

export const LiveDot = styled("span", {
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  flexShrink: 0,

  variants: {
    active: {
      true: { backgroundColor: "$success" },
      false: { backgroundColor: "$gray-70" },
    },
  },
});

/** The ⓘ tooltip: which version patients answer, what each state means, and why this one is read-only. */
export const HelpCard = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "16px",
  fontFamily: "$openSans",
  fontSize: "13px",
  lineHeight: "18px",
  color: "$charcoal",
});

export const HelpLive = styled("p", {
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 12px",
  borderRadius: "8px",
  backgroundColor: "$success-lightest",
  color: "$success-dark",
  fontWeight: 600,
});

export const HelpStates = styled("ul", {
  listStyle: "none",
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: "10px",

  li: {
    display: "grid",
    gridTemplateColumns: "84px 1fr",
    alignItems: "start",
    gap: "10px",
  },

  [`& ${Badge}`]: { textAlign: "center", fontSize: "12px", padding: "2px 8px" },
});

export const HelpNote = styled("p", {
  margin: 0,
  padding: "8px 12px",
  borderLeft: "3px solid $primary",
  borderRadius: "4px",
  backgroundColor: "$secondary-lightest",
  color: "$charcoal",
});
